import { Box, Button } from '@mantine/core'
import { IconHistory } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'

/** Icon size for the compact (xs) history button. */
const HISTORY_ICON_SIZE = 14

interface LessonsAssessmentsLinkProps {
  onClick: () => void
}

/**
 * Per-student "View assessments" button (final assessment only).
 *
 * Opens the shared `AssessmentHistoryModal` with the student's lesson-level
 * assessments for this standard, served by the legacy
 * `POST /api/projects/:id/partial_evaluations` endpoint — the same source and
 * modal the legacy final assessment page uses (`EvaluativeItem`).
 *
 * The `Box` wrapper keeps the button at content width inside the row's
 * stretched `Stack` column.
 */
export function LessonsAssessmentsLink({ onClick }: LessonsAssessmentsLinkProps) {
  const { t } = useTranslation()
  return (
    <Box>
      <Button variant="light" size="xs" leftIcon={<IconHistory size={HISTORY_ICON_SIZE} />} onClick={onClick}>
        {t('arc_partial_history_button')}
      </Button>
    </Box>
  )
}
